import { EmailNewsLetterObserver as Tagmanager} from 'core/tag-manager/emailNewsLetter.observer'
import { InputValidationComponent } from 'core/validation/input/input-validation.component'
import { FormValidationComponent } from 'core/validation/form/form-validation.component'
import { NewsletterService } from './newsletter.service'
import { NewsletterObserver } from './newsletter.observer'
import { constraintsPromocao} from './../newsletter-promocao/constraintsPromocao'
import { constraints } from './constraints'
import { Observable, Subject } from 'rxjs'
import { CadastroMask } from './masks'

export class NewsletterComponent {
    constructor() {
        this.masks = new CadastroMask()
        this.newsletterForm = document.querySelector('#newsletter-form')
        this.newsletterFormTopo = document.querySelector('#newsletter-form-topo')
        this.termosClick = document.querySelector('#termosClick')
        this.service = new NewsletterService()
        this.init()
    }

    init() {
          if(this.newsletterForm) {
          let validator = new FormValidationComponent(this.newsletterForm, constraints)
          let submitStream = Observable.fromEvent(this.newsletterForm, 'submit');
          //Submit NewsLetter Event
          submitStream
            .do(event => event.preventDefault())
            .filter(() => validator.validateForm())
            .map(event => validator.serializeForm())
            .map(email => this.buildObj(email))
            .subscribe(data => this.enviarEmail(data))
          //Change Input Event Component
          new InputValidationComponent(this.newsletterForm, constraints).init()
        }

        if(this.newsletterFormTopo) {
            let validator = new FormValidationComponent(this.newsletterFormTopo, constraintsPromocao)
            let submitStream = Observable.fromEvent(this.newsletterFormTopo, 'submit');
            //Submit NewsLetter Event
            submitStream
            .do(event => event.preventDefault())
            .filter(() => {
              if (!document.querySelector('#termos').checked) {
                const atencao = document.querySelector('#atencao');
                if (atencao != null) atencao.hidden = false;
                return false;
              }
              return true;
            })
            .filter(() => validator.validateForm())
            .map(event => validator.serializeForm())
            .map(res => this.buildObjTopo(res))
            .do(email => this.enviarEmail(email))
              .subscribe(() => {
                document.getElementById('name-id').value = ""
                document.getElementById('cpf-id').value = ""
                document.getElementById('email-id').value = ""
                document.getElementById('phone-id').value = ""
              })
            //Change Input Event Component
            new InputValidationComponent(this.newsletterFormTopo, constraints).init()
        }
    }

    buildObj(email) {
        return { 
            email: email.email,
            origem: this.newsletterForm.getAttribute('data-origem')
        }
    }

    buildObjTopo(res) {
        let nomeCompleto = res.name.split(' ')
        let nome = nomeCompleto.shift()
        let sobrenome = ''
        for (let i=0; i < nomeCompleto.length; i++) {
          if (sobrenome == '') {
            sobrenome = nomeCompleto[i]
          } else {
            sobrenome = sobrenome + ' ' + nomeCompleto[i]
          }
        }

        return {
            email: res.email,
            origem: this.newsletterFormTopo.getAttribute('data-origem'),
            firstName: nome,
            lastName: sobrenome,
            cpf: Number(res.cpf).toString(),
            telefone: res.telefone,
        }
    }

    enviarEmail(data) {
        let emailEnviadoSubject = new Subject();
        emailEnviadoSubject.subscribe(new NewsletterObserver())
        emailEnviadoSubject.subscribe(new Tagmanager())

        return this.service
                    .enviarEmailNewsLetter(data)
                    .subscribe({
                        next: response => emailEnviadoSubject.next(response),
                        error: error => emailEnviadoSubject.error(error),
                        complete: () => console.log("Complete")
                    });
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/newsletter/newsletter.component.js